module.exports = __webpack_public_path__ + "img/49.533f4556.jpg";